define('models/transfer/user_search_collection',[
	'backbone',
	'models/transfer/suggestion_search_item'
], function(Backbone, SuggestionSearchItem) {
	var UserSearchCollection = Backbone.Collection.extend({

		model: SuggestionSearchItem,

		initialize: function(options){
			options = options || {};
			this.search_data = options.search_data;
			this.limit = (options.limit) ? options.limit : 40;
		},
		url: function(){
			var url = pf.awsSearchUrl + '/users?c=' + this.limit + '&start=0&q=' + this.search_data;
			return url;
		},
		parse: function(data){
			var response = {};
			// console.log('parse data',data);
			response = data;
			return response;
		}
	});
	return UserSearchCollection;
});

